import { token } from '@/infrastructure/container';
import type { SessionEvent, SessionState } from '@/domain/session';

// The facade the coach screen talks to, pinned by session/contracts/p3-voting.md. The real
// implementation sits over @celeriant/sdk; tests hand the store an in-memory one.
//
// STUB. P3's implementation fills this in. The interface is the frozen part.

export interface ICoachGateway {
  // ONE `occ: false` execute. Resolves on the server ack, which is NOT the same instant the event
  // reaches state: a non-OCC write response carries no version the SDK may advance the read cursor
  // with, so the event lands on the next catch-up or realtime poke (docs/sync.md). A caller that
  // treats resolution as "it is in the fold now" is wrong, and the oracle's fake is deliberately
  // unkind about it.
  //
  // Rejects translated into the taxonomy: OfflineError (the device never had a network, the SDK's
  // failFastWhenOffline path), ServerError, UpdateRequiredError, and ConflictError. ConflictError
  // is NOT a version clash here — `occ: false` sends no version guard — but it is still reachable:
  // the SDK raises it once its own three retries are exhausted on any ambiguous failure, a thrown
  // network call included. It is AMBIGUOUS by construction: the write may already have landed on
  // the server, so a caller must not read it as "nothing happened" (session/scraps.md).
  execute(event: SessionEvent, opts: { idempotencyKey: string }): Promise<void>;
  readonly sessionState: SessionState; // MobX observable, the current fold
  // The AND of the device's own network interface and whether the gateway is answering, with the
  // clear/latch semantics `src/services/GatewayReach.ts` owns (docs/sync.md, "Failure handling").
  readonly connectionOk: boolean; // MobX observable
}

export const TOKEN_ICoachGateway = token<ICoachGateway>('ICoachGateway');
